<template>

  <section class="tables">
    <div class="page-header">
      <h3 class="page-title">
        <span class="menu-icon">
          <i class="mdi mdi-email"></i>
        </span>
        Mailboxes Addresses
      </h3>
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><router-link to="/">Dashboard</router-link></li>
          <li class="breadcrumb-item active" aria-current="page">Mailboxes</li>
        </ol>
      </nav>
    </div>
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <b-button @click="createAMailBox()" variant="primary" class="ml-3">Create A New Mailbox</b-button>
            <b-modal
                id="modal-create-a-mailbox"
                ref="modal"
                :title="'Change Password For: ' + mailboxToChangePassword"
                @show="resetModal"
                @hidden="resetModal"
                @ok="handleOk"
            >
              <form autocomplete="off" ref="form" @submit.stop.prevent="createMailBoxForm">
                <label for="new-email-name">Enter the new email name</label>
                <b-row>
                  <b-col>
                    <b-form-group
                        invalid-feedback="New email name is required"
                        :state="newPasswordState">
                      <b-form-input
                          type="email"
                          id="new-email-name"
                          v-model="newEmailName"
                          :state="newEmailNameState"
                          required
                          autocomplete="false">
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    @domain.com
                  </b-col>
                </b-row>
              </form>
            </b-modal>
            <h4 class="card-title"></h4>
            <div v-if="!items.length">
              <b-spinner type="grow" class="float-left"></b-spinner>
              <p class="float-left mt-1 ml-1">Prismyk is loading your mailboxes...</p>
            </div>
            <b-table responsive :items="items">
              <template #cell(actions)="row">
                <b-dropdown toggle-class="mailbox-dropdown" variant="secondary">
                  <template slot="button-content">
                    <i class="mdi mdi-menu"></i>
                  </template>
                  <b-dropdown-item>Manage</b-dropdown-item>
                  <b-dropdown-item @click="setmailboxToChangePassword(row.item.mailBox)">Change Password</b-dropdown-item>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item @click="showMsgBoxDeleteMailbox(row.item.mailBox)">Delete</b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>

          </div>
        </div>
      </div>
      <b-modal
          id="modal-change-mailbox-password"
          ref="modal"
          :title="'Change Password For: ' + mailboxToChangePassword"
          @show="resetModal"
          @hidden="resetModal"
          @ok="handleOk"
      >
        <form autocomplete="off" ref="form" @submit.stop.prevent="handleSubmit">
          <b-form-group
              label="New Password"
              label-for="new-password"
              invalid-feedback="New Password is required"
              :state="newPasswordState"
          >
            <b-form-input
                type="password"
                id="new-password"
                v-model="newPassword"
                :state="newPasswordState"
                required
                new-password
                autocomplete="false"
            ></b-form-input>
          </b-form-group>
          <b-form-group
              label="Confirm New Password"
              label-for="confirm-new-password"
              invalid-feedback="New Password Confirmation is required"
              :state="confirmNewPasswordState"
          >
            <b-form-input
                type="password"
                id="confirm-new-password"
                v-model="confirmNewPassword"
                :state="confirmNewPasswordState"
                required
                new-password
                autocomplete="false"
            ></b-form-input>
          </b-form-group>
        </form>
      </b-modal>
    </div>
  </section>

</template>
<style lang="scss">
  .mailbox-dropdown {
    &:after {
      content: none;
    }
  }
</style>
<script>
export default {
  name: 'Pricing',
  data () {
    return {
      domains: {},
      websitesList: {},
      fields: ['mailBox', 'actions'],
      items: [],
      mailboxToDelete: '',
      mailboxToChangePassword: ''
    }
  },
  props: {
    lng: String,
    langKeys: Object,
    setActualLng: Function,
    setSwitch: Function,
    lngSwitch: Object,
    getHomeFilters: Function,
    setUserInfos: Function,
    hideLoader: Function,
    showLoader: Function,
    setToken: Function,
    getImages: Function,
    signUpMessage: String,
    imageSearch: String,
    userEmail: String,
    newUser: Function,
    listALlMailbox: Function
  },
  watch: {
    domains (to, from) {
      for (const val in this.domains) {
        this.items.push({ mailBox: this.domains[val].login + '@' + this.domains[val].domain,actions:true })
      }
    }
  },
  components: {
  },
  computed: {
  },
  methods: {
    setMailBoxToDelete (mailbox) {
      this.console.log(mailbox)
      this.mailboxToDelete = mailbox
    },
    createAMailBox () {
      this.$bvModal.show('modal-create-a-mailbox')
    },
    setmailboxToChangePassword (mailbox) {
      this.mailboxToChangePassword = mailbox
      this.$bvModal.show('modal-change-mailbox-password')
    },
    showMsgBoxDeleteMailbox() {
      this.boxTwo = ''
      this.$bvModal.msgBoxConfirm('Please confirm that you want to delete everything.', {
        title: 'Please Confirm',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
          .then(value => {
            this.boxTwo = value
          })
          .catch(err => {
            // An error occurred
          })
    }
  },
  created () {},
  async mounted () {
    this.domains = await this.listALlMailbox()
  }
}
</script>